

export const URLBase = 'https://hp-api.onrender.com/api/characters';